import { asDetailResponse, asPaginatedResponse, useApi, useDetailApi, usePaginatedApi } from "../../../swr/useApi";
import { warrantyClaimsSellerService } from "../../api_client";
import type {
  WarrantyClaimDto,
  WarrantyClaimQueryDto,
  WarrantyClaimStatsDto,
} from "../../../api";

// The list endpoint returns the full WarrantyClaimDto shape (SerializePaginated strips messages)
export type WarrantyClaimListDto = WarrantyClaimDto;
export type { WarrantyClaimDto, WarrantyClaimStatsDto };

export type SupplierClaimsQuery = {
  page?: number;
  pageSize?: number;
  status?: string;
};

export function useSupplierWarrantyClaims(query?: SupplierClaimsQuery) {
  return usePaginatedApi<WarrantyClaimListDto, SupplierClaimsQuery>({
    key: "supplier-warranty-claims",
    serviceMethod: async (q) =>
      asPaginatedResponse<WarrantyClaimListDto>(
        warrantyClaimsSellerService.listSupplierClaims(q as unknown as WarrantyClaimQueryDto),
      ),
    query,
    options: { refreshInterval: 15_000 },
  });
}

export function useSupplierClaimDetails(id: string | null) {
  return useDetailApi<WarrantyClaimDto>({
    key: id ? `supplier-warranty-claim-${id}` : null,
    serviceMethod: () => asDetailResponse<WarrantyClaimDto>(warrantyClaimsSellerService.getSupplierClaimDetail(id!)),
  });
}

export function useSupplierClaimStats() {
  return useApi<WarrantyClaimStatsDto>(
    "supplier-warranty-claim-stats",
    () => asDetailResponse<WarrantyClaimStatsDto>(warrantyClaimsSellerService.getSupplierClaimStats()),
    { refreshInterval: 15_000 },
  );
}
